export enum POSTCODE_PROVIDER_ERROR {
    NETWORK_ERROR = -1,
    PARSE_ERROR = -2,
    ABORT_ERROR = -3,
    NOT_VALID_ERROR = -4
}

export const ZIP_REGEX = /^[0-9]*$/;

export const CITY_REGEX = /^([^0-9]*)$/;

export const STREET_REGEX = new RegExp(/^(\p{Letter}*)$/u);

export const HOUSE_REGEX = /^[0-9]*$/;
